import type { Quiz } from 'features/quizzes/types';

export const resetQuiz = (quiz: Quiz) => {
  quiz.completionsCount = 0;
  quiz.editable = false;
  quiz.status = 'created';
  quiz.submitted = false;
};
